module.exports = __webpack_public_path__ + "img/img-7-desk.94fa3a04.jpg";